import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const CardLoader = () => {
  return (
    <div style={{ minHeight: '228px' }} className='p-3 card sr-card mb-3 d-flex flex-column'>
      <Skeleton height={24} width='65%' />
      <Skeleton height={90} width='100%' />

      <div className='mt-auto d-flex'>
        <div>
          <SkeletonTheme duration={2} width={'150px'} height={44}>
            <Skeleton />
          </SkeletonTheme>
        </div>
        <div className='ms-auto'>
          <SkeletonTheme borderRadius='5rem' duration={2} height={46} width={100}>
            <Skeleton />
          </SkeletonTheme>
        </div>
      </div>
    </div>
  );
};

const ServiceOptionLoader = () => {
  return (
    <div className='overflow-auto'>
      <div className='col-sm-6 mb-4 pb-2'>
        <Skeleton height={48} />
      </div>
      <div className='row'>
        <div className='mb-2'>
          <Skeleton height={24} width={170} />
        </div>
        {new Array(3).fill(0).map((_, ind) => (
          <div className='col-sm-6' key={ind}>
            <CardLoader />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceOptionLoader;
